export default function SectionHeading({ eyebrow, title, description, align = "start" }) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <div className="sas-eyebrow mb-3">{eyebrow}</div>}
      <h2 className="sas-h2">{title}</h2>
      {description && <p className="sas-lead mt-4">{description}</p>}
    </div>
  );
}
